
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlanDefinitions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lob"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coverageType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stateCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"countyFipsCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isDualYear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPlanDefinitions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lob"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lob"}}},{"kind":"Argument","name":{"kind":"Name","value":"coverageType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coverageType"}}},{"kind":"Argument","name":{"kind":"Name","value":"planYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planYear"}}},{"kind":"Argument","name":{"kind":"Name","value":"stateCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stateCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"countyFipsCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"countyFipsCode"}}},{"kind":"Argument","name":{"kind":"Name","value":"isDualYear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isDualYear"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medicarePlanType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"searchDirectory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reciprocityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telehealthIndicator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayAcceptsMedicaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clusterKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupDriven"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestPath"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"planCategories"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planDetails"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planIdentifier"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"medicarePlanType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"searchDirectory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"years"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reciprocityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"telehealthIndicator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"displayAcceptsMedicaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clusterKey"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupDriven"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"guestPath"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":996}};
    doc.loc.source = {"body":"query GetPlanDefinitions(\n  $lob: String!\n  $coverageType: String!\n  $planYear: String!\n  $stateCode: String\n  $countyFipsCode: String\n  $isDualYear: Boolean\n) {\n  getPlanDefinitions(\n    lob: $lob\n    coverageType: $coverageType\n    planYear: $planYear\n    stateCode: $stateCode\n    countyFipsCode: $countyFipsCode\n    isDualYear: $isDualYear\n  ) {\n    planDetails {\n      planName\n      planIdentifier\n      medicarePlanType\n      searchDirectory\n      years {\n        planYear\n        reciprocityId\n        telehealthIndicator\n        displayAcceptsMedicaid\n        clusterKey\n        groupDriven\n        guestPath\n      }\n    }\n    planCategories {\n      planCategory\n      planDetails {\n        planName\n        planIdentifier\n        medicarePlanType\n        searchDirectory\n        years {\n          planYear\n          reciprocityId\n          telehealthIndicator\n          displayAcceptsMedicaid\n          clusterKey\n          groupDriven\n          guestPath\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetPlanDefinitions"] = oneQuery(doc, "GetPlanDefinitions");
        
